import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import moment from 'moment'

// Actions
import { CreateSaveCustomerGroup, getCustomerGroups, getCustomerGroup, addCustomerGroupCustomers, removeCustomerGroupCustomer } from '../../../actions/customerGroup'
import { getShopCustomers } from '../../../actions/customers'
import { triggerPopup } from '../../../actions/backdrop'
import { updateCustomerWPInfo, getCustomerContactsInfo } from '../../../actions/customerWP'

// Components
// import HelpText from '../../../shared/components/HelpText'
import Portal from '../../../shared/components/Portal'
import Confirm from '../../../shared/components/Confirm'

// Elements
import { ElementIcons } from '../../../shared/elements/icons'
import Actions from '../../../shared/elements/actions'
import Button from '../../../shared/elements/button'
import Check from '../../../shared/elements/check'
import Col from '../../../shared/elements/col'
import DropDown from '../../../shared/elements/dropDown'
import Icon from '../../../shared/elements/icon'
import Label from '../../../shared/elements/label'
import LabelWrapper from '../../../shared/elements/labelWrapper'
import Panel from '../../../shared/elements/panel'
import Row from '../../../shared/elements/row'
import Switch from '../../../shared/elements/switch'
import Text from '../../../shared/elements/text'
import Textarea from '../../../shared/elements/textarea'
import Grid from '../../../shared/elements/grid'
import Divider from '../../../shared/elements/divider'
import Inline from '../../../shared/elements/inline'
import RemoveButton from '../../../shared/elements/removeButton'
import HelpIcon from '../../../shared/elements/helpIcon'
import CloseButton from '../../../shared/elements/closeButton'

// Styles
import './view.scss'
import '../customergroups.scss'

// Utils
import { hasAccess } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'

class View extends Component {

  constructor (props) {
    super(props)
    this.state = {
      type: 'create',
      customergroup: {
        CustomerGroupId: 0,
        Active: true,
        Name: '',
        Comment: '',
        CustomerGroupContacts: {},
        CustomerGroupCustomers: {}
      },
      customersList: [],
      selectedCustomers: [],
      selectedShopId: -1,
      selectedCustomerId: -1,
      confirmSelect: {
        open: false,
        customerId: -1,
        customerGroup: ''
      },
      dealerExpand: false,
      selectedDealer: {
        CustomerId: 0,
        Name: ''
      },
      orderBy: {
        nameDesc: false,
        zipDesc: true,
        zipImg: <img />,
        nameImg: <img style={{width: '15px', transform: 'rotate(180deg)', marginLeft: '7px'}} src='/images/svgs/Arrow_up-down.svg' />
      }
    }
    this.saveAddCustomerGroup = this.saveAddCustomerGroup.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.renderBasic = this.renderBasic.bind(this)
    this.renderContacts = this.renderContacts.bind(this)
    this.renderCustomerSelection = this.renderCustomerSelection.bind(this)
    this.renderCustomersList = this.renderCustomersList.bind(this)
    this.onSelectCustomer = this.onSelectCustomer.bind(this)
    this.addCustomerGroupCustomers = this.addCustomerGroupCustomers.bind(this)
  }

  componentDidMount () {
    this.getCustomerGroup(this.props)
    this.getShopCustomers()
  }

  getShopCustomers () {
    let shopId = this.state.selectedShopId
    if (Number(shopId) !== Number(-1)) {
      this.props.getShopCustomers(shopId).then((res) => {
        this.setState({
          customersList: res.data
        })
      })
    } else {
      this.setState({
        customersList: []
      })
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.item.CustomerGroupId !== nextProps.item.CustomerGroupId) {
      this.getCustomerGroup(nextProps)
    }
  }

  onChange (e) {
    e.persist()
    let value = e.target.value

    if (e.target.type === 'radio') {
      value = (e.target.value === 'yes')
    }
    if (e.target.name === 'DimentionNumber') {
      if (isNaN(value)) {
        value = parseInt(this.state.customergroup.DimentionNumber)
      } else {
        value = parseInt(value)
      }
    }
    if (e.target.type === 'checkbox') {
      value = e.target.checked
    }
    this.setState({
      type: this.state.type,
      customergroup: {
        ...this.state.customergroup,
        [e.target.name]: value
      }
    }, () => {
      if (e.target.type === 'radio' || e.target.type === 'checkbox') {
        this.onBlur(e)
      }
    })
  }

  onInputChange (name, e) {
    let value = ''
    if (moment.isMoment(e)) {
      value = e
    } else {
      if (typeof e === 'undefined') {
        e = name
      }
      name = e.target.name
      value = e.target.value
      if (e.target.type === 'radio') {
        value = (e.target.value === 'yes')
      }
    }
    // console.log('e.target.value ', e.target.value, value, e.target.name)
    if (e.target.name === 'selectedShopId') {
      this.setState({
        selectedShopId: value,
        selectedCustomers: []
      }, () => {
        // console.log('this.state.selectedShopId after onChange ', this.state.selectedShopId)
        this.getShopCustomers()
      })
    } else {
      this.setState({
        customergroup: {
          ...this.state.customergroup,
          [name]: value
        }
      })
    }
  }

  onSelect (customer) {
    this.setState({
      confirmSelect: {
        open: true,
        customerId: customer.CustomerId,
        customerGroup: customer.CustomerGroupName
      }
    })
  }
  onSelectCustomer (e) {
    let value = Number(e.target.value)
    let selectedCustomers = [...this.state.selectedCustomers]
    if (selectedCustomers.includes(value)) {
      selectedCustomers = selectedCustomers.filter(function (el) {
        return Number(el) !== value
      })
    } else {
      let cust = this.state.customersList.filter(function (eg) {
        return Number(eg.CustomerId) === value
      })[0]
      if (cust.CustomerGroupId > 0) {
        this.onSelect(cust)
      } else {
        selectedCustomers.push(value)
      }
    }
    this.setState({
      selectedCustomers: selectedCustomers
    })
  }
  onRemoveCustomer (key, companyId) {
    let data = {
      CustomerId: key,
      CompanyId: companyId,
      CustomerGroupId: this.props.item.CustomerGroupId
    }
    this.props.removeCustomerGroupCustomer(data).then((res) => {
      this.getCustomerGroup(this.props)
      // window.toastr.success(translation('13031'), translation('13424'))
    }, (err) => {
      // Toastr
      if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
        let errors = err.response.data.Errors
        let errText = ''
        for (let i = 0; i < errors.length; i++) {
          let dictKey = errors[i].DictionaryKey
          errText += '<br/>' + translation(dictKey)
        }
        window.toastr.error(translation(errText), translation('216'))
      } else {
        window.toastr.error(translation('12307'), translation('216'))
      }
    })
  }
  onBlur (e) {
    if (this.state.customergroup.CustomerGroupId !== undefined && this.state.customergroup.CustomerGroupId > 0) {
      this.saveAddCustomerGroup(this.state.customergroup)
      if (e.target.name === 'Name') {
        this.props.getCustomerGroups()
      }
    }
  }
  getCustomerGroup (props) {
    if (typeof props.item.CustomerGroupId !== 'undefined' && props.item.CustomerGroupId > 0) {
      props.getCustomerGroup(props.item.CustomerGroupId).then((res) => {
        this.setState({
          type: 'edit',
          customergroup: res.data,
          selectedShopId: -1,
          customersList: [],
          selectedCustomers: [],
          dealerExpand: false
        }, () => {
          this.getShopCustomers()
        })
      })
    } else {
      this.resetCreate()
    }
  }

  resetCreate () {
    this.setState({
      type: 'create',
      customergroup: {
        Name: '',
        Active: true,
        DebitorNumber: '',
        DimentionNumber: '',
        Comment: '',
        CustomerGroupContacts: {},
        CustomerGroupCustomers: {}
      },
      customersList: [],
      selectedCustomers: [],
      selectedShopId: -1,
      selectedCustomerId: -1,
      confirmSelect: {
        open: false,
        customerId: -1,
        customerGroup: ''
      }
    })
  }
  addCustomerGroupCustomers () {
    let { selectedCustomers } = this.state
    if (selectedCustomers === undefined || selectedCustomers == null || selectedCustomers.length === 0) return
    let data = {
      SelectedShopId: this.state.selectedShopId,
      CustomerGroupId: this.props.item.CustomerGroupId,
      CustomersList: this.state.selectedCustomers.map((key, val) => {
        let CustomerGroupCustomerDto = {
          CustomerId: key
        }
        return CustomerGroupCustomerDto
      })
    }
    this.props.changeLoading(true)
    this.props.addCustomerGroupCustomers(data).then((res) => {
      this.getCustomerGroup(this.props)
      this.props.changeLoading(false)
      // window.toastr.success(translation('13030'), translation('13424'))
    }, (err) => {
      this.props.changeLoading(false)
      // Toastr
      if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
        let errors = err.response.data.Errors
        let errText = ''
        for (let i = 0; i < errors.length; i++) {
          let dictKey = errors[i].DictionaryKey
          errText += '<br/>' + translation(dictKey)
        }
        window.toastr.error(translation(errText), translation('216'))
      } else {
        window.toastr.error(translation('12306'), translation('216'))
      }
    })
  }
  saveAddCustomerGroup () {
    return this.props.CreateSaveCustomerGroup(this.state.customergroup).then((res) => {
      this.props.onSave(res.data, this.state.type)
      // console.log('Saved.. ', res.data)
      setTimeout(() => {
        this.props.getCustomerGroups()
      }, 0)
    }, (err) => {
      // Toastr
      if (err.response.data.Errors !== undefined && err.response.data.Errors !== null && err.response.data.Errors.length > 0) {
        let errors = err.response.data.Errors
        let errText = ''
        for (let i = 0; i < errors.length; i++) {
          let dictKey = errors[i].DictionaryKey
          errText += '<br/>' + translation(dictKey)
        }
        window.toastr.error(translation(errText), translation('216'))
      } else {
        window.toastr.error(translation('13465'), translation('216'))
      }
    })
  }

  renderBasic () {
    let { customergroup } = this.state
    let isChain = hasAccess([2], this.props.auth.user.UserType)
    let isWp = hasAccess([6], this.props.auth.user.UserType)
    // if (hasAccess([2], this.props.auth.user.UserType)) {
    return (
      <Panel title={translation('12282')}>
        <Text name='Name' value={customergroup.Name || ''} onChange={this.onChange} onBlur={this.onBlur} disabled={!isChain} labelText={translation('30')} />
        <LabelWrapper labelText={translation('149')}>
          <Textarea name='Comment' value={customergroup.Comment || ''} onChange={this.onChange} onBlur={this.onBlur} disabled={!isChain} />
        </LabelWrapper>
        {isChain && (<Switch name='Active' onChange={this.onChange} checked={customergroup.Active} labelText={translation('295')} />)}
        {isWp && (
          <Text name='DebitNr' value={customergroup.DebitNr || ''} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('13452')} helpText={translation('1945')} />
        )}
        {isWp && (
          <Text name='DimentionNumber' value={customergroup.DimentionNumber || ''} onChange={this.onChange} onBlur={this.onBlur} labelText={translation('15202')} helpText={translation('15203')} />
        )}
        {isWp && (
          <LabelWrapper labelText={translation('18143')} helpText={translation('')}>
            <Check name='UseWPDealerNrInYourRef' checked={customergroup.UseWPDealerNrInYourRef} onChange={this.onChange} />
          </LabelWrapper>
        )}
      </Panel>
    )
  }
  renderContacts () {
    if (this.state.type === 'create') return null
    if (hasAccess([2], this.props.auth.user.UserType)) {
      let { customergroup } = this.state

      const renderContact = (val, key) => {
        return (
          <Label key={key}>
            <Link to={'/customergroups/' + customergroup.CustomerGroupId + '/contacts/' + val.ContactId}>{val.Name}</Link>
          </Label>
        )
      }

      return (
        <Panel title={translation('13460')}>
          <Actions>
            <Link to={'/customergroups/' + customergroup.CustomerGroupId + '/contacts'}>
              <div className='hint--left' aria-label={translation('12305')}>
                <Icon icon={ElementIcons.Edit} size='t' />
              </div>
            </Link>
          </Actions>

          {customergroup.CustomerGroupContacts !== undefined && customergroup.CustomerGroupContacts !== null ? customergroup.CustomerGroupContacts.map(renderContact) : undefined}
        </Panel>
      )
    }
  }

  renderCustomersList () {
    if (this.state.type === 'create') return null
    if (!hasAccess([2, 6], this.props.auth.user.UserType)) return null
    let { customergroup } = this.state
    let formExtraClass = 'extra'
    if (!this.state.dealerExpand) {
      formExtraClass += ' hide'
    }

    const deleteItem = (key) => {
      this.onRemoveCustomer(customergroup.CustomerGroupCustomers[key].CustomerId, customergroup.CustomerGroupCustomers[key].CustomerCompanyId)
    }

    const renderDealerContacts = (val, key) => {
      return (
        <div key={key}>
          <Grid>
            <label>{translation('30')}:</label>
            <label>{val.Name}</label>
          </Grid>
          <Grid>
            <label>{translation('1')}:</label>
            <label>{val.UserName}</label>
          </Grid>
          <Grid>
            <label>{translation('1052')}:</label>
            <label>{val.Email}</label>
          </Grid>
          <Grid>
            <label>{translation('345')}:</label>
            <label>{val.Phone}</label>
          </Grid>
          <Divider />
        </div>
      )
    }

    const renderDealerInfo = (data) => {
      // console.log('renderDealerInfo: ', data)
      if (data === null || data === undefined || data.CustomerId === 0) return
      return (
        <div>
          <Grid>
            <div>{translation('30')}:</div>
            <div>{data.CompanyName}</div>
          </Grid>
          <Grid>
            <div>{translation('25')}:</div>
            <div>{data.CompanyAddress + ', ' + data.CompanyZipCode + ' ' + data.CompanyCity}</div>
          </Grid>
          <Grid>
            <div>{translation('41')}:</div>
            <div>{data.CompanyCVR}</div>
          </Grid>
          <Grid>
            <div>{translation('38')}:</div>
            <div>{data.CompanyPhoneNumber}</div>
          </Grid>
          <Grid>
            <div>{translation('93')}:</div>
            <div>{data.Notes}</div>
          </Grid>
        </div>
      )
    }

    const renderDealerShopInfo = (data) => {
      // console.log('renderDealerInfo: ', data)
      if (data === null || data === undefined || data.ShopName === undefined) return
      return (
        <Grid>
          <div>{translation('30')}:</div>
          <div>{data.ShopName}</div>
        </Grid>
      )
    }

    const onCollapseClick = () => {
      this.setState({
        dealerExpand: !this.state.dealerExpand,
        selectedDealer: {
          CustomerId: 0,
          Name: ''
        }
      })
    }

    const renderDealer = (val, key) => {
      let helptext = ''
      const getDiv = (val, key) => {
        return (<ul key={key + '0'}>
          <li key={key} >{translation('12308')}:</li>
          {val.map(renderConstraints)}
        </ul>)
      }
      const renderDName = (val, key) => {
        return (<li key={key}>-- {val.Name}
        </li>)
      }
      const renderConstraints = (val, key) => {
        if (hasAccess([2], this.props.auth.user.UserType)) {
          return (
            <ul><li key={key}>{val.Name}</li>
              {val.Constraints.map(renderDName)}
            </ul>
          )
        } else {
          return (<li key={key}>{val.Name}</li>)
        }
      }

      const onItemChange = (e) => {
        e.persist()
        let isCheckBox = e.target.type === 'checkbox'
        let value = isCheckBox ? e.target.checked : e.target.value
        let field = e.target.name
        let customerGroupCustomers = this.state.customergroup.CustomerGroupCustomers
        let customer = customerGroupCustomers[key]

        if (field === 'DimentionNumber') {
          if (isNaN(value)) {
            value = parseInt(customer[field])
          } else {
            value = parseInt(value)
          }
        }

        customer[field] = value
        customerGroupCustomers[key] = customer

        this.setState({
          customergroup: {
            ...this.state.customergroup,
            CustomerGroupCustomers: [...customerGroupCustomers]
          }
        }, () => {
          if (isCheckBox) onItemBlur()
        })
      }

      const onItemBlur = () => {
        let customergroup = this.state.customergroup
        let customerGroupCustomers = this.state.customergroup.CustomerGroupCustomers
        let customer = customerGroupCustomers[key]

        let data = {
          CustomerId: customer.CustomerId,
          CustomerCompanyId: customer.CustomerCompanyId,
          DebitorNrForWP: customer.DebitorNrForWP,
          DimentionNumber: customer.DimentionNumber,
          UseWPDealerNrInYourRef: customer.UseWPDealerNrInYourRef,
          UseDebitorNrForWP: customer.UseDebitorNrForWP,
          WPDealerNr: customer.WPDealerNr,
          CustomerGroupId: customergroup.CustomerGroupId
        }

        this.props.updateCustomerWPInfo(data).then(res => {
          this.setState({
            customergroup: res.data
          })

          // window.toastr.success(translation('12316'), translation('13424'))
        }, () => {
          window.toastr.error(translation('12317'), translation('216'))
        })
      }

      // same "if" condition 2 times, but different HelpText
      if (val.CustomerGroups !== undefined && val.CustomerGroups !== null && val.CustomerGroups.length > 1) {
        let text = getDiv(val.CustomerGroups, key)
        helptext = <HelpIcon helpText={text} />
      }

      const onDealerClick = () => {
        this.props.getCustomerContactsInfo(val.CustomerId).then((res) => {
          let customer = res.data.Customer
          if (customer.CustomerId === 0) customer.CustomerId = val.CustomerId
          // let customerId = res.data.CustomerId
          // if (customerId === null || customerId === 0) customerId = val.CustomerId
          this.setState({
            customerContactsList: res.data.Contacts,
            dealerExpand: true,
            selectedDealer: customer
            // selectedDealer: {
            //   CustomerId: val.CustomerId,
            //   Name: val.Name
            // }
          })
        })
      }
      let dealerNameClass = 'dealer'
      if (this.state.selectedDealer.CustomerId === val.CustomerId) {
        dealerNameClass += ' selected'
      }
      if (hasAccess([2], this.props.auth.user.UserType)) {
        // To show shop of customer in the name
        let shownName = val.Name + ' (' + val.CustomerCompanyName + ')'
        return (
          <Grid spacing={1} key={key} cols={[0.5, 2, 'min-content']} align={'center'}>
            <div>{val.ZipCode}</div>
            <div>
              {shownName}
              {helptext}
            </div>
            <RemoveButton size='m' name={key} onClick={deleteItem.bind(this, key)} />
          </Grid>
        )
      }

      // same "if" condition 2 times, but different HelpText
      if (val.CustomerGroups !== undefined && val.CustomerGroups !== null && val.CustomerGroups.length > 1) {
        let text = getDiv(val.CustomerGroups)
        helptext = <HelpIcon helpText={text} red={val.ConflictStatus === 1} green={val.ConflictStatus === 2} />
      }

      let isChecked = val.UseDebitorNrForWP
      let debitorInput = (<Text labelText={translation('13452')} helpText={translation('1945')} size='s' name={'DebitorNrForWP'} value={val.DebitorNrForWP} onBlur={onItemBlur} onChange={onItemChange} disabled={!isChecked} />)

      return (
        <div key={key}>
          <Grid align={'center'}>
            <div onClick={onDealerClick} className={dealerNameClass}>{val.Name} <Label>{val.CustomerCompanyName}</Label></div>
            <Text labelText={translation('13559')} helpText={translation('13560')} size='s' name={'WPDealerNr'} value={val.WPDealerNr || ''} onBlur={onItemBlur} onChange={onItemChange} disabled={!val.IsPrimaryCustomer} />
            <LabelWrapper labelText={translation('12314')} helpText={translation('12315')}><Check simple name='UseDebitorNrForWP' checked={isChecked} onChange={onItemChange} disabled={!val.IsPrimaryCustomer} /></LabelWrapper>
            { /* !isChecked ? debitorInput : <div /> */ }
          </Grid>
          {isChecked && (<Grid align={'center'}>
            <div />
            {debitorInput}
            <Text labelText={translation('15202')} helpText={translation('15203')} size='s' name={'DimentionNumber'} value={val.DimentionNumber || ''} onBlur={onItemBlur} onChange={onItemChange} disabled={!val.IsPrimaryCustomer} />
          </Grid>)}
        </div>
      )
    }

    const orderBy = (type) => {
      if (type === 1) {
        this.setState({
          customergroup: {
            ...this.state.customergroup,
            CustomerGroupCustomers: this.state.orderBy.zipDesc ? this.state.customergroup.CustomerGroupCustomers.sort((a, b) => { return a.ZipCode.localeCompare(b.ZipCode) }) : this.state.customergroup.CustomerGroupCustomers.sort((a, b) => { return b.ZipCode.localeCompare(a.ZipCode) })
          },
          orderBy: {
            ...this.state.orderBy,
            zipDesc: !this.state.orderBy.zipDesc,
            zipImg: this.state.orderBy.zipDesc ? <img style={{width: '15px', marginLeft: '7px'}} src='/images/svgs/Arrow_up-down.svg' /> : <img style={{width: '15px', transform: 'rotate(180deg)', marginLeft: '7px'}} src='/images/svgs/Arrow_up-down.svg' />,
            nameImg: <img />
          }
        })
      } else if (type === 2) {
        this.setState({
          customergroup: {
            ...this.state.customergroup,
            CustomerGroupCustomers: this.state.orderBy.nameDesc ? this.state.customergroup.CustomerGroupCustomers.sort((a, b) => { return a.Name.localeCompare(b.Name) }) : this.state.customergroup.CustomerGroupCustomers.sort((a, b) => { return b.Name.localeCompare(a.Name) })
          },
          orderBy: {
            ...this.state.orderBy,
            nameDesc: !this.state.orderBy.nameDesc,
            nameImg: this.state.orderBy.nameDesc ? <img style={{width: '15px', transform: 'rotate(180deg)', marginLeft: '7px'}} src='/images/svgs/Arrow_up-down.svg' /> : <img style={{width: '15px', marginLeft: '7px'}} src='/images/svgs/Arrow_up-down.svg' />,
            zipImg: <img />
          }
        })
      }
    }

    let zip = <div style={{width: '20%', float: 'left'}}><div style={{width: 'fit-content', cursor: 'pointer'}} onClick={() => orderBy(1)}>{translation('40')}{this.state.orderBy.zipImg}</div></div>
    let name = <div style={{marginLeft: '20%'}}><div style={{width: 'fit-content', cursor: 'pointer'}} onClick={() => orderBy(2)}>{translation('12304')}{this.state.orderBy.nameImg}</div></div>

    let colClassName = ''
    if (this.state.dealerExpand) {
      colClassName += ' expandable'
    }

    return (
      <Panel title={translation('12304')}>
        {hasAccess([2], this.props.auth.user.UserType) && (<div className='title'>{zip} {name}</div>)}
        <Inline alignChildren='top'>
          <div className={'real' + colClassName}>
            {customergroup.CustomerGroupCustomers !== undefined && customergroup.CustomerGroupCustomers !== null ? customergroup.CustomerGroupCustomers.map(renderDealer) : undefined}
          </div>
          {this.state.dealerExpand && (
            <div className={formExtraClass + colClassName}>
              <div className='title-spacing'>
                <Grid cols={[1, 'min-content']} align='center'>
                  <h3>{this.state.selectedDealer.CompanyName}</h3>
                  <CloseButton onClick={onCollapseClick} />
                </Grid>
              </div>
              <LabelWrapper labelText={translation('13600')}>
                {renderDealerInfo(this.state.selectedDealer)}
              </LabelWrapper>
              <LabelWrapper labelText={translation('1737')}>
                {renderDealerShopInfo(this.state.selectedDealer)}
              </LabelWrapper>
              <LabelWrapper labelText={translation('13601')}>
                {this.state.customerContactsList !== undefined ? this.state.customerContactsList.map(renderDealerContacts) : null}
              </LabelWrapper>
            </div>
          )}
        </Inline>
      </Panel>
    )
  }

  renderShopSelection () {
    const renderShopsList = () => {
      if (this.props.shopsList === undefined || this.props.shopsList === null) return null
      return this.props.shopsList.reduce((shops, val, i) => {
        if (val.Active) {
          let opt = <option value={val.ShopId} key={val.ShopId}>{val.ShopName}</option>
          return [...shops, opt]
        }
        return shops
      }, [])
    }
    if (this.state.type === 'create') return null
    if (!hasAccess([2], this.props.auth.user.UserType)) return null
    // console.log('this.state.selectedShopId ', this.state.selectedShopId)
    return (
      <Panel title={translation('12303')}>
        <DropDown name='selectedShopId' onChange={this.onInputChange} value={this.state.selectedShopId}>
          <option value={-1} key='-1'>{translation('890')}</option>
          {renderShopsList()}
        </DropDown>
      </Panel>
    )
  }
  renderAddCustomerButton () {
    let { customersList } = this.state
    if (customersList === undefined || customersList == null || customersList.length === 0) return undefined
    return (
      <Button onClick={this.addCustomerGroupCustomers} labelText={translation('1208')} />
    )
  }
  renderCustomerSelection () {
    if (this.state.type === 'create') return null
    if (!hasAccess([2], this.props.auth.user.UserType)) return null
    let { customersList } = this.state
    let hasCustomers = customersList !== undefined && customersList !== null && customersList.length > 0
    if (!hasCustomers) return undefined

    // const getDiv = (val, key) => {
    //   return (<div>
    //     <div key={key} >{translation('12308')}:</div>
    //     {val.map(renderDName)}
    //   </div>)
    // }
    // const renderDName = (val, key) => {
    //   let name = val.Name + ' (' + val.WorkProviderName + ')'
    //   return (<div key={key}>{name}</div>)
    // }
    const renderDNameNew = (val) => {
      return '\n' + val.Name + ' (' + val.WorkProviderName + ')'
    }
    const checked = (key) => {
      let selectedCustomers = [...this.state.selectedCustomers]
      return selectedCustomers.includes(Number(key))
    }

    const renderCustomerCheckBox = (val, key) => {
      let { customergroup } = { ...this.state }
      let cust = this.state.customersList.filter(function (eg) {
        return Number(eg.CustomerId) === Number(val.CustomerId) &&
          Number(val.CustomerGroupId) === customergroup.CustomerGroupId
      })[0]
      if (cust !== undefined) return undefined
      let name = 'customerCheck_' + val.CustomerId
      let helptext = ''
      let customerWorkProviderId = -1
      if (val.CustomerGroups !== undefined && val.CustomerGroups !== null && val.CustomerGroups.length > 0) {
        let text = translation('12302') + ' '
        let count = val.CustomerGroups.length
        let i = 0
        val.CustomerGroups.forEach(element => {
          i++
          let textName = ' ' + element.Name
          if (i < count) {
            textName += ','
          }
          text += textName
          customerWorkProviderId = element.WorkProviderId
        })
        // text = getDiv(val.CustomerGroups, key)
        text = translation('12308') + ':'
        let dNames = val.CustomerGroups.map(renderDNameNew)
        text += dNames
        if (text !== '') {
          helptext = text
        }
      }

      let partnerName = ''
      if (val.RelationType === 2) { // 2 = FromPartner
        partnerName = `\n(${val.PartnerName})`
      }

      let isChecked = checked(val.CustomerId) || false
      let currentWorkProviderId = this.state.customergroup.WorkProviderId
      let isActive = customerWorkProviderId === -1 || currentWorkProviderId === customerWorkProviderId
      let ZipCode = val.ZipCode !== '' && val.ZipCode !== null ? ` (${val.ZipCode})` : ''
      return (
        <Check key={key} disabled={!isActive} id={name} value={val.CustomerId} onChange={this.onSelectCustomer} checked={isChecked} name={name} labelText={val.Name + ZipCode + partnerName} helpText={helptext} />
      )
    }

    const activeCustomers = customersList.filter(c => c.Active)
    return (
      <Panel title={translation('12301')}>
        {hasCustomers ? activeCustomers.map(renderCustomerCheckBox) : <Label>{translation('433')}</Label>}
        {this.renderAddCustomerButton()}
      </Panel>
    )
  }
  render () {
    // let classNameList = (this.state.type === 'edit') ? 'view_edit' : 'view_create'
    const confirmSelect = (props) => {
      let ctext = props.t('12300')
      return (
        <div>
          <div>
            {ctext}
          </div>
          <div>
            {this.state.confirmSelect.customerGroup}
          </div>
        </div>
      )
    }
    return (
      <Row>
        <Col>
          {this.renderBasic()}
          {this.renderContacts()}
        </Col>
        <Col span={hasAccess([2], this.props.auth.user.UserType) ? '2' : '5'}>
          {this.renderShopSelection()}
          {this.renderCustomerSelection()}
          {this.renderCustomersList()}
        </Col>
        {this.state.confirmSelect.open && (
          <Portal className='confirm_popup' onPortalClose={this.onPortalClose.bind(this, 'confirmSelect')}>
            <Confirm confirm={this.onConfirmSelect.bind(this)} notConfirm={this.onPortalClose.bind(this, 'confirmSelect')} higher renderText={confirmSelect} />
          </Portal>
        )}
      </Row>
    )
  }
  onPortalClose (type) {
    this.setState({
      [type]: {
        ...this.state[type],
        open: false,
        customerId: -1,
        customerGroup: ''
      }
    })
  }
  onConfirmSelect () {
    let value = Number(this.state.confirmSelect.customerId)
    let selectedCustomers = [...this.state.selectedCustomers]
    selectedCustomers.push(value)
    this.setState({
      selectedCustomers: selectedCustomers
    })
    this.onPortalClose('confirmSelect')
  }
}

View.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    phonecode: state.common.phonecode,
    phonecodes: state.common.phonecodes,
    selectedShopId: state.selectedShopId
  }
}

export default connect(mapStateToProps, {
  CreateSaveCustomerGroup,
  getCustomerGroups,
  getCustomerContactsInfo,
  getCustomerGroup,
  getShopCustomers,
  addCustomerGroupCustomers,
  triggerPopup,
  removeCustomerGroupCustomer,
  updateCustomerWPInfo
}, null, { withRef: true })(View)



// WEBPACK FOOTER //
// ./src/app/pages/CustomerGroups/View/index.js